<template>
  <div class="card-form">
    <PageHeader ref="header" slot="header" @query="getData" @reset="resetPage">
      <dict-select
        slot="left"
        ref="expoInfoSelect"
        v-model="expoInfoCode"
        :selectedLabel.sync="expoInfoName"
        url="/digitalCenter/expo/info/dictSelect"
        :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        size="small"
        filterable
        @loaded="expoInfoLoaded"
        @change="expoInfoChange"
      />
      <template #right>
        <b-form-radio-group
          v-model="showType"
          :options="[
            { text: $l('radio_text_timeZone_A') || '按时区', value: 'A' },
            { text: $l('radio_text_timeZone_B') || '本地时间', value: 'B' },
          ]"
          class="ml-2"
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-outline"
          buttons
          @change="reload"
        />
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEdit({ type: 'add' })"
          v-if="allow('A')"
        >
          {{ $l('btn_add') || '新增' }}
        </b-button>
      </template>
    </PageHeader>

    <PageMain
      ref="main"
      class="main"
      :data="tableData"
      :loading="loading"
      :showType="showType"
      @reload="reload"
      @openEdit="openEdit"
      @open-comments-doc="openCommentsDoc"
    />

    <pagination
      size="small"
      align="right"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :expoMeetingCode="editOptions.expoMeetingCode"
      :expoInfoCode="expoInfoCode"
      @reload="reload"
    />

    <DetailDrawer
      :visible.sync="detailOptions.visible"
      :expoMeetingCode="detailOptions.expoMeetingCode"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import EditForm from '../edit-form'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import DetailDrawer from '../detail'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, EditForm, DetailDrawer },
  data() {
    return {
      usePage: true,
      editOptions: { visible: false, expoMeetingCode: '', type: '' },
      detailOptions: { visible: false, expoMeetingCode: '' },
      expoInfoCode: '',
      expoInfoName: '',
      localTimeZone: '',
      showType: 'A',
    }
  },
  activated() {
    if (this.expoInfoCode) this.$refs.expoInfoSelect.init()
  },
  methods: {
    expoInfoLoaded(data) {
      if (this.expoInfoCode) return
      if (!data || !data.length) return
      const { value: expoInfoCode, label: expoInfoName } = data[0]
      if (!expoInfoCode) return
      this.$refs.header.reset()
      this.expoInfoCode = expoInfoCode
      this.expoInfoName = expoInfoName
      this.$refs.header.query()
    },
    expoInfoChange() {
      this.$refs.header.reset()
      this.$refs.header.query()
    },
    async getData(form) {
      if (!this.expoInfoCode) return

      const localTimeZone = await this.loadLocalTimeZone()
      this.loading = true
      const res = await this.$api
        .expoMeetingTimelineApi({
          ...form,
          ...this.page,
          expoInfoCode: this.expoInfoCode,
          localTimeZone,
          showType: this.showType,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    async openEdit({ type, data: { expoMeetingCode } = {} }) {
      if (type == 'add' && !this.expoInfoCode) {
        this.$message.warning(
          this.$l('tips_emptyExpoInfo') || '没有展会信息，无法安排新的会议'
        )
        return
      }
      if (type != 'add') {
        this.loadingOpen()
        const res = await this.$api
          .expoMeetingCheckAuthApi({ expoMeetingCode, checkType: 'B' })
          .catch(() => false)
        this.loadingClose()
        if (!res) return
        const { status, msg } = res
        if (status === 203) {
          this.$confirm(
            msg,
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            }
          )
          return
        }
      }
      this.editOptions = { visible: true, type, expoMeetingCode }
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`
        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    openCommentsDoc({ expoMeetingCode }) {
      this.detailOptions = { visible: true, expoMeetingCode }
    },
  },
}
</script>
